import { useParams } from 'react-router'
import { type PropsWithChildren, createContext, useContext, useEffect, useState } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ChatbotDialogStore } from 'pages/chatbot'

const ChatbotDialogContext = createContext<ChatbotDialogStore | null>(null)

export const useChatbotDialogContext = () => {
  const context = useContext(ChatbotDialogContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ChatbotDialogProvider')

  return context
}

export const ChatbotDialogProvider = ({ children }: PropsWithChildren) => {
  const { agentId } = useParams()
  const entities = useEntitiesContext()

  const [store] = useState(() => new ChatbotDialogStore(agentId, entities))

  useEffect(() => store.dispose, [])

  return <ChatbotDialogContext.Provider value={store}>{children}</ChatbotDialogContext.Provider>
}
